// 原本照筆劃排，後來總經理要求特定幾項調整排序

export default function (filter) {
  const adminGroupCategories = {
    id: '0',
    name_tw: '群組清單',
    product_category_ids_sorts: [
      // {
      //   id: 'group-company-info',
      //   name_tw: '公司資訊',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'company-introduction',
      //       name_tw: '公司簡介',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '1'
      // },
      // {
      //   id: 'group-company',
      //   name_tw: '公司',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'company-zone',
      //       name_tw: '區域',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     },
      //     {
      //       id: 'company-industry',
      //       name_tw: '行業別',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '2'
      //     },
      //     {
      //       id: 'company-trade',
      //       name_tw: '產業',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '3'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '2'
      // },
      {
        id: 'group-user',
        name_tw: '使用者',
        product_category_ids_sorts: [
          {
            id: 'user-role',
            name_tw: '角色',
            product_category_ids_sorts: [],
            product_ids_sorts: [],
            sort: '1'
          },
          {
            id: 'user-group',
            name_tw: '使用者群組',
            product_category_ids_sorts: [],
            product_ids_sorts: [],
            sort: '2'
          },
          {
            id: 'user-account',
            name_tw: '帳戶管理',
            product_category_ids_sorts: [],
            product_ids_sorts: [],
            sort: '3'
          }
        ],
        product_ids_sorts: [],
        sort: '3'
      },
      // {
      //   id: 'group-news',
      //   name_tw: '新聞',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'news-type',
      //       name_tw: '新聞分類',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     },
      //   ],
      //   product_ids_sorts: [],
      //   sort: '4'
      // },
      // {
      //   id: 'group-work-log',
      //   name_tw: '工作日誌',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'work-nature',
      //       name_tw: '工作性質',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     },
      //     {
      //       id: 'work-progress',
      //       name_tw: '工作進度',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '2'
      //     },
      //     // {
      //     //   id: 'work-log-edit-time-setting',
      //     //   name_tw: '編輯時限設定',
      //     //   product_category_ids_sorts: [],
      //     //   product_ids_sorts: [],
      //     //   sort: '3'
      //     // },
      //     {
      //       id: 'project-progress',
      //       name_tw: '專案狀態',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '4'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '5'
      // },
      // {
      //   id: 'group-media-cloud',
      //   name_tw: '媒體雲',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'media-cloud-file-attribute',
      //       name_tw: '檔案屬性',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     },
      //     {
      //       id: 'media-cloud-file-attribute-value',
      //       name_tw: '檔案屬性值',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '2'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '6'
      // },
      // {
      //   id: 'group-repair-service',
      //   name_tw: '維修服務單',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'supervisor-evaluation',
      //       name_tw: '主管評核',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     },
      //     {
      //       id: 'repair-area',
      //       name_tw: '地區',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '2'
      //     },
      //     {
      //       id: 'repair-status',
      //       name_tw: '表單狀態',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '3'
      //     },
      //     {
      //       id: 'repair-form-type',
      //       name_tw: '表單類型',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '4'
      //     },
      //     {
      //       id: 'repair-warranty-type',
      //       name_tw: '保固類型',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '5'
      //     },
      //     // {
      //     //   id: 'repair-product-from',
      //     //   name_tw: '產品來源',
      //     //   product_category_ids_sorts: [],
      //     //   product_ids_sorts: [],
      //     //   sort: '6'
      //     // },
      //     {
      //       id: 'repair-service-type',
      //       name_tw: '服務類別',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '7'
      //     },
      //     {
      //       id: 'repair-owner-judgement',
      //       name_tw: '責任歸屬',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '8'
      //     },
      //     {
      //       id: 'repair-currency',
      //       name_tw: '幣別',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '9'
      //     },
      //     {
      //       id: 'repair-service-satisfaction',
      //       name_tw: '服務結果',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '10'
      //     },
      //     {
      //       id: 'repair-issue-type',
      //       name_tw: '問題分類',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '11'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '7'
      // },
      // {
      //   id: 'group-system-environment',
      //   name_tw: '系統環境',
      //   product_category_ids_sorts: [
      //     {
      //       id: 'system-parameter-setting',
      //       name_tw: '系統參數',
      //       product_category_ids_sorts: [],
      //       product_ids_sorts: [],
      //       sort: '1'
      //     }
      //   ],
      //   product_ids_sorts: [],
      //   sort: '8'
      // }
    ],
    product_ids_sorts: [],
    sort: '1'
  };

  if (filter.isSuperAdmin === '0') {
    adminGroupCategories.product_category_ids_sorts.splice(6, 1);
  }

  return adminGroupCategories;
};


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/adminGroupCategories.js